module.exports = __webpack_public_path__ + "static/img/1030.8c25ef5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1030.jpg
// module id = 212
// module chunks = 0